import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setLanguage } from 'src/features/language/store';

export const useSwitchToBrowserLanguageIfSupported = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const updateLng = useCallback(
    (lang: string) => () => {
      dispatch(setLanguage({ lang }));
      i18n.changeLanguage(lang);
    },
    [i18n, dispatch],
  );

  useEffect(() => {
    const browserLanguage = navigator.language;

    // if brower exist then extrat from it the language fr-FR => fr

    if (browserLanguage) {
      const lang = browserLanguage.split('-')[0];

      if (browserLanguage && ['ar', 'fr', 'en'].includes(lang)) {
        updateLng(browserLanguage);
      }
    }
  }, [updateLng]);
};
